<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      lastTouchEnd: 0,
    };
  },
  mounted() {
    document.addEventListener("gesturestart", this.preventGestureZoom);

    document.addEventListener("touchend", this.preventDoubleTapZoom, { passive: false });
  },
  methods: {
    preventGestureZoom(event) {
      event.preventDefault();
    },
    preventDoubleTapZoom(event) {
      const now = new Date().getTime();
      if (this.lastTouchEnd && now - this.lastTouchEnd <= 300) {
        event.preventDefault();
      }
      this.lastTouchEnd = now;
    },
  },
  beforeDestroy() {
    document.removeEventListener("gesturestart", this.preventGestureZoom);
    document.removeEventListener("touchend", this.preventDoubleTapZoom);
  },
};
</script>

<style>
@import './assets/css/common.css';
</style>